/**
 * Used as a better-supported alternative to `Promise.withResolvers()`
 */
class Deferred<T = void> {
  public promise: Promise<T>

  // @ts-expect-error Definitely assigned in the constructor
  public resolve: (value: T | PromiseLike<T>) => void

  // @ts-expect-error Definitely assigned in the constructor
  public reject: (reason?: any) => void

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }
}

export const promiseWithResolvers = <T = void>() => 'withResolvers' in Promise ? Promise.withResolvers<T>() : new Deferred<T>()
